import { LogoutReason, LogoutUsecase, Usecase } from '..'

export class FixVersionUsecase extends Usecase {
    /**
     * This function should only be manually called
     */
    invoke (): void {
        this.getUsecase(LogoutUsecase).logout(LogoutReason.MANUAL_LOGOUT)

        /**
         * Reloading the page should do it
         */
        this.browserService.reload()
    }
}
